"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;

require("regenerator-runtime/runtime");

var _Store = require("./Store");

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

require("./window");

var _EventDispatcher2 = _interopRequireDefault(require("./EventDispatcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var addEventDetails = function addEventDetails(eventMessage, event) {
  Object.keys(eventMessage).forEach(function (key) {
    if (key !== 'action' && key) {
      event.eventData = _objectSpread({}, event.eventData, _defineProperty({}, key, eventMessage[key]));
    }
  });
  return event;
};

var MaestroIFrameSDK = /*#__PURE__*/function (_EventDispatcher) {
  _inherits(MaestroIFrameSDK, _EventDispatcher);

  var _super = _createSuper(MaestroIFrameSDK);

  function MaestroIFrameSDK(_ref) {
    var _this;

    var element = _ref.element,
        locale = _ref.locale,
        slug = _ref.slug,
        urlOverride = _ref.urlOverride,
        platform = _ref.platform;

    _classCallCheck(this, MaestroIFrameSDK);

    _this = _super.call(this);
    _this._element = element;
    _this._slug = slug;
    _this._urlOverride = urlOverride;
    _this._locale = locale;
    _this._store = (0, _Store.store)(_Store.reducer);
    _this._platform = platform;

    window.onmessage = function (messageFromMaestro) {
      var data = messageFromMaestro.data;

      if (Object.values(_types.EventType).includes(data.action)) {
        var action = data.action;
        var newEvent = new Event(action);
        var eventToDispatch = addEventDetails(messageFromMaestro.data, newEvent);

        _this.dispatchEvent(eventToDispatch);
      } else if (Object.values(_types.MessagesFromMaestroWeb).includes(data.action)) {
        // we now recieve messages from maestro that aren't events we want to bubble up and dispatch
        var _action = data.action;

        switch (_action) {
          case _types.MessagesFromMaestroWeb.LOGIN_COMPLETE:
            {
              _this._store.dispatch((0, _Store.setLoginCompleteMessage)(true));

              break;
            }

          case _types.MessagesFromMaestroWeb.RETURN_ACCOUNT:
            {
              var account = data.account,
                  loggedIn = data.loggedIn;

              _this._store.dispatch((0, _Store.setMaestroAccount)({
                account: account,
                loggedIn: loggedIn
              }));

              break;
            }

          case _types.MessagesFromMaestroWeb.ACCOUNT_SET:
            {
              var maestroAccount = data.account;

              _this._store.dispatch((0, _Store.setAccountMessageData)({
                maestroAccount: maestroAccount,
                thirdPartyAccount: true,
                accountSet: true
              }));

              break;
            }

          case _types.MessagesFromMaestroWeb.LOGOUT_COMPLETE:
            {
              _this._store.dispatch((0, _Store.logout)());

              break;
            }
        }
      }
    };

    return _this;
  }

  _createClass(MaestroIFrameSDK, [{
    key: "getUserAccount",
    value: function () {
      var _getUserAccount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _this$_store$getState, maestroAccount, iframeWindow, unsubscribe, listenerPromise;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._element) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Maestro Iframe SDK was not instantiated with a valid HTML Element');

              case 2:
                _this$_store$getState = this._store.getState(), maestroAccount = _this$_store$getState.maestroAccount;

                if (!maestroAccount) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", maestroAccount);

              case 5:
                iframeWindow = this.getIframeWindow(this._element); // subscribe to the accountSet property in the store and call on change if account is set than dispatch event

                unsubscribe = this._store.subscribe(function () {
                  var _this2$_store$getStat = _this2._store.getState(),
                      accountSet = _this2$_store$getStat.accountSet,
                      maestroLoggedIn = _this2$_store$getStat.maestroLoggedIn;

                  if (!accountSet && maestroLoggedIn) {
                    return;
                  }

                  var accountReturnedEvent = new Event(_types.InternalMaestroSDKEvents.ACCOUNT_RETURNED);

                  _this2.dispatchEvent(accountReturnedEvent);
                });
                iframeWindow.postMessage({
                  action: _types.InternalMaestroMessages.GET_MAESTRO_ACCOUNT,
                  source: _types.IFrameMessageSource.IFRAME_SDK
                }, '*');
                listenerPromise = new Promise(function (resolve) {
                  // this promise resolves when the internal event in the subscribe function is dispatched
                  _this2.addEventListener(_types.InternalMaestroSDKEvents.ACCOUNT_RETURNED, function () {
                    // this._store.unSubscribe('getAccount');
                    resolve(_this2._store.getState().maestroAccount);
                    unsubscribe();
                  }, {
                    once: true
                  });
                });
                return _context.abrupt("return", listenerPromise);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserAccount() {
        return _getUserAccount.apply(this, arguments);
      }

      return getUserAccount;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(account) {
        var _this3 = this;

        var iframeWindow, unsubscribe, listenerPromise;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._element) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Maestro Iframe SDK was not instantiated with a valid HTML Element');

              case 2:
                this._store.dispatch((0, _Store.setThirdPartyAccount)(account));

                iframeWindow = this.getIframeWindow(this._element); // here we subscribe to the loginComplete and run on change

                unsubscribe = this._store.subscribe(function () {
                  var _this3$_store$getStat = _this3._store.getState(),
                      loginComplete = _this3$_store$getStat.loginComplete;

                  if (loginComplete) {
                    var loginCompleteEvent = new Event(_types.InternalMaestroSDKEvents.LOGIN_COMPLETE);

                    _this3.dispatchEvent(loginCompleteEvent);
                  }
                });
                iframeWindow.postMessage({
                  action: _types.EventType.REQUEST_LOGIN,
                  account: account,
                  source: _types.IFrameMessageSource.IFRAME_SDK
                }, '*');
                listenerPromise = new Promise(function (resolve) {
                  _this3.addEventListener(_types.InternalMaestroSDKEvents.LOGIN_COMPLETE, function () {
                    unsubscribe(); // this promise resolves when we have recieved the message back from maestro web and the internal event has fired

                    resolve(_this3._store.getState().loginComplete);
                  }, {
                    once: true
                  });
                });
                return _context2.abrupt("return", listenerPromise);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function login(_x) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;

      if (!this._element) {
        throw new Error('Maestro Iframe SDK was not instantiated with a valid HTML Element');
      }

      var iframeWindow = this.getIframeWindow(this._element);

      var unsubscribe = this._store.subscribe(function () {
        var _this4$_store$getStat = _this4._store.getState(),
            logoutComplete = _this4$_store$getStat.logoutComplete;

        if (logoutComplete) {
          var logoutCompleteEvent = new Event(_types.InternalMaestroSDKEvents.LOGOUT_COPLETE);

          _this4.dispatchEvent(logoutCompleteEvent);
        }
      });

      iframeWindow.postMessage({
        action: _types.EventType.REQUEST_LOGOUT,
        source: _types.IFrameMessageSource.IFRAME_SDK
      }, '*');
      var listenerPromise = new Promise(function (resolve) {
        // this promise resolves when the internal event in the subscribe function is dispatched
        _this4.addEventListener(_types.InternalMaestroSDKEvents.LOGOUT_COPLETE, function () {
          resolve(_this4._store.getState().logoutComplete);
          unsubscribe();
        }, {
          once: true
        });
      });
      return listenerPromise;
    }
  }, {
    key: "off",
    value: function off(type, callback) {
      this.removeEventListener(type, callback || null);
      return;
    }
  }, {
    key: "on",
    value: function on(type, callback) {
      this.addEventListener(type, callback);
      return;
    }
  }, {
    key: "render",
    value: function render(viewOptions) {
      var _this5 = this;

      if (!this._element) {
        throw new Error('Maestro Iframe SDK was not instantiated with a valid HTML Element');
      }

      var maestroIframe = document.createElement('iframe');

      if (!maestroIframe) {
        throw new Error('Mestro Iframe could not be created');
      }

      maestroIframe.allowFullscreen = true;
      maestroIframe.frameBorder = '0';
      maestroIframe.marginHeight = '0';
      maestroIframe.marginWidth = '0';
      maestroIframe.width = '100%';
      maestroIframe.height = '100%';
      maestroIframe.className = 'Maestro-Iframe';
      maestroIframe.id = 'Embedded-Maestro-Iframe';
      maestroIframe.allow = 'camera; microphone; document-domain';
      maestroIframe.allowPaymentRequest = true;

      this._element.appendChild(maestroIframe);

      maestroIframe.onload = function () {
        if (maestroIframe.contentWindow) {
          maestroIframe.contentWindow.postMessage({
            action: _types.InternalMaestroMessages.REQUEST_LAYOUT,
            source: _types.IFrameMessageSource.IFRAME_SDK,
            viewOptions: viewOptions
          }, '*');

          if (_this5._locale) {
            maestroIframe.contentWindow.postMessage({
              action: _types.InternalMaestroMessages.INIT_LOCALE,
              source: _types.IFrameMessageSource.IFRAME_SDK,
              locale: _this5._locale
            }, '*');
          }
        }
      };

      maestroIframe.src = "".concat(this._urlOverride || "https://sapphire.maestro.io", "/").concat(this._slug, "?iframe_sdk=iframe&platform=").concat(this._platform);
      return;
    }
  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      if (!this._element) {
        throw new Error('HTML Element not given in constructor or does note exist');
      }

      var iframeWindow = this.getIframeWindow(this._element);
      iframeWindow.postMessage({
        action: _types.EventType.LOCALE_CHANGE,
        source: _types.IFrameMessageSource.IFRAME_SDK,
        locale: locale
      }, '*');
      this._locale = locale;
      return;
    }
  }, {
    key: "getIframeWindow",
    value: function getIframeWindow(element) {
      var iframe = element.getElementsByTagName('iframe')[0];
      var iframeWindow;

      if (!iframe) {
        throw new Error('Iframe not appended to dom');
      }

      iframeWindow = iframe.contentWindow;

      if (!iframeWindow) {
        throw new Error('iframe window could not be accessed');
      }

      return iframeWindow;
    }
  }]);

  return MaestroIFrameSDK;
}(_EventDispatcher2.default);

exports.default = MaestroIFrameSDK;